/**
 * Confirmation Dialog Module
 *
 * Provides reusable Bootstrap modal confirmation dialogs.
 * Replaces native browser confirm() with better UX.
 */

/**
 * Show a confirmation dialog
 * @param {Object} options - Dialog configuration
 * @param {string} options.title - Dialog title
 * @param {string} options.message - Dialog message (can include HTML)
 * @param {string} [options.confirmText='Pokračovat'] - Confirm button text
 * @param {string} [options.cancelText='Zrušit'] - Cancel button text
 * @param {string} [options.confirmButtonClass='btn-primary'] - Confirm button CSS class
 * @param {Function} [options.onConfirm] - Callback when user confirms
 * @param {Function} [options.onCancel] - Callback when user cancels
 * @returns {Object} Modal jQuery object
 */
export function showConfirmationDialog(options) {
    const defaults = {
        title: 'Potvrzení',
        message: 'Opravdu chcete pokračovat?',
        confirmText: 'Pokračovat',
        cancelText: 'Zrušit',
        confirmButtonClass: 'btn-primary',
        onConfirm: null,
        onCancel: null
    };

    const settings = { ...defaults, ...options };

    // Create unique modal ID
    const modalId = `confirmModal_${Date.now()}`;

    // Create modal HTML
    const modalHtml = `
        <div class="modal fade" id="${modalId}" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">${settings.title}</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        ${settings.message}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">${settings.cancelText}</button>
                        <button type="button" class="btn ${settings.confirmButtonClass} js-confirm-action">${settings.confirmText}</button>
                    </div>
                </div>
            </div>
        </div>
    `;

    // Add modal to DOM
    $('body').append(modalHtml);
    const $modal = $(`#${modalId}`);

    // Show modal
    $modal.modal('show');

    // Track if user confirmed
    let isConfirmed = false;

    // Handle confirm button click
    $modal.find('.js-confirm-action').on('click', () => {
        isConfirmed = true;
        $modal.modal('hide');
        if (settings.onConfirm && typeof settings.onConfirm === 'function') {
            settings.onConfirm();
        }
    });

    // Handle cancel/close
    $modal.on('hidden.bs.modal', () => {
        // If not confirmed, call cancel callback
        if (!isConfirmed && settings.onCancel && typeof settings.onCancel === 'function') {
            settings.onCancel();
        }
        // Clean up - remove modal from DOM
        $modal.remove();
    });

    return $modal;
}

/**
 * Show a danger confirmation dialog (e.g., for delete operations)
 * @param {Object} options - Dialog configuration (same as showConfirmationDialog)
 * @returns {Object} Modal jQuery object
 */
export function showDangerConfirmationDialog(options) {
    return showConfirmationDialog({
        ...options,
        confirmButtonClass: 'btn-danger',
        confirmText: options.confirmText || 'Smazat'
    });
}

/**
 * Show a warning confirmation dialog
 * @param {Object} options - Dialog configuration (same as showConfirmationDialog)
 * @returns {Object} Modal jQuery object
 */
export function showWarningConfirmationDialog(options) {
    return showConfirmationDialog({
        ...options,
        confirmButtonClass: 'btn-warning',
        confirmText: options.confirmText || 'Pokračovat'
    });
}

export default {
    showConfirmationDialog,
    showDangerConfirmationDialog,
    showWarningConfirmationDialog
};
